module.exports = __webpack_public_path__ + "static/media/showroom.b0ceda61.svg";